import { getAddressAnalyticsByNetwork } from "./actions/getAddressSnapshotsByNetwork";
import { getAddressAnalyticsByWallet } from "./actions/getAddressSnapshotsByWallet";
import { getAdvAnalytics } from "./actions/getAdvBalanceSnapshots";

export const actions = {
  getAddressAnalyticsByNetwork,
  getAddressAnalyticsByWallet,
  getAdvAnalytics
};